window.Workarea = function () {
    var el = this;
    el.workAreaScale = 1;
    el.templateData = {};
    el.workareas = {};
    el.workarea_formats = {};
    el.currentWorkarea = {};

    function getViewArea() {
        var $el = $('#hardcover-wrapper');

        var pos = {
            width: $el.width(),
            height: $el.width() / el.workData.width * el.workData.height
        };

        var availHeight = $(window).height();
        $('#page-step-constructor .navbar').each(function () {
            availHeight -= $(this).outerHeight();
        });

        availHeight -= $('.top-panel').outerHeight();
        availHeight = availHeight - $('.book').outerHeight() + $('.book').height();

        if (pos.height > availHeight && pos.width >= 768) {
            pos.height = availHeight;
            pos.width = parseInt(pos.height / el.workData.height * el.workData.width);
        }

        return pos;
    }

    function setCurrentWorkarea(workareaId) {
        if (!workareaId && el.project.current.workarea_id !== '0') {
            workareaId = el.project.current.workarea_id;
        }

        workareaId = workareaId ? workareaId : Object.keys(el.workareas)[0];
        el.currentWorkarea = el.workareas[workareaId];
    }

    function reinit(sourceDimensions) {
        sourceDimensions.width = (parseInt(sourceDimensions.width) + 2 * parseInt(el.currentProduct.company.valve)) / el.MM_IN_PIXELS;
        sourceDimensions.height = (parseInt(sourceDimensions.height) + 2 * parseInt(el.currentProduct.company.valve)) / el.MM_IN_PIXELS;

        el._parent.workData.source_width = sourceDimensions.width;
        el._parent.workData.source_height = sourceDimensions.height;
        el._parent.workData.scale = sourceDimensions.width / el.WORKAREA_WIDTH;
        el._parent.workData.height = Math.round(sourceDimensions.height / el.workData.scale);


        el._parent.workData.workareas[1].source_width = sourceDimensions.width;
        el._parent.workData.workareas[1].source_height = sourceDimensions.height;
        el._parent.workData.workareas[1].height = el.workData.height;
        el._parent.workData.workareas[1].format_id = el.format.current.id;

        var workareas = el._parent.workData.workareas;
        var workareaId, workarea, backgroundId, background;
        for (workareaId in workareas) {
            workarea = workareas[workareaId];

            workarea.cells = {};
            workarea.images = {};
            workarea.layers = {};
            workarea.texts = {};
            workarea.decors = {};

            for (backgroundId in workarea.backgrounds) {
                background = workarea.backgrounds[backgroundId];

                if (background === null) {
                    continue;
                }

                el.upImages.onloadImage(
                        {
                            width: background.width,
                            height: background.height
                        },
                        'backgrounds',
                        workareaId,
                        backgroundId,
                        background.name
                        );
                el.upImages.setUsedImage(background.name);
            }
        }
    }

    el.init = function () {
        var sourceDimensions = {
            width: el.format.current.width,
            height: el.format.current.height
        };

        if (Object.keys(el.workareas).length !== 0 && Object.keys(el.currentWorkarea).length === 0) {
            setCurrentWorkarea();
        }

        if (Object.keys(el.workareas).length !== 0) {
            sourceDimensions.width = el.currentWorkarea.width;
            sourceDimensions.height = el.currentWorkarea.height;
        }

        sourceDimensions.width = (parseInt(sourceDimensions.width) + 2 * parseInt(el.currentProduct.company.valve)) / el.MM_IN_PIXELS;
        sourceDimensions.height = (parseInt(sourceDimensions.height) + 2 * parseInt(el.currentProduct.company.valve)) / el.MM_IN_PIXELS;

        el._parent.workData = {
            width: el.WORKAREA_WIDTH,
            height: 0,
            source_width: sourceDimensions.width,
            source_height: sourceDimensions.height,
            scale: sourceDimensions.width / el.WORKAREA_WIDTH,
            is_single_content: 0,
            orientation: 0,
            workareas: {}
        };

        el._parent.workData.height = Math.round(sourceDimensions.height / el.workData.scale);

        if (Object.keys(el.workareas).length !== 0) {
            el._parent.workData.is_single_content = el.currentWorkarea.is_single_content;

            var i, workareaFormat, format, number = 1;
            for (i in el.workarea_formats) {
                workareaFormat = el.workarea_formats[i];

                if (workareaFormat.workarea_id === el.currentWorkarea.id) {
                    format = el.format.items[workareaFormat.format_id];

                    el._parent.workData.workareas[number] = {
                        width: Math.round(format.width / el.MM_IN_PIXELS / el.workData.scale),
                        height: Math.round(format.height / el.MM_IN_PIXELS / el.workData.scale),
                        left: Math.round((parseInt(workareaFormat.x) + parseInt(el.currentProduct.company.valve)) / el.MM_IN_PIXELS / el.workData.scale),
                        top: Math.round((parseInt(workareaFormat.y) + parseInt(el.currentProduct.company.valve)) / el.MM_IN_PIXELS / el.workData.scale),
                        source_width: format.width / el.MM_IN_PIXELS,
                        source_height: format.height / el.MM_IN_PIXELS,
                        format_id: format.id,
                        cells: {},
                        images: {},
                        backgrounds: {},
                        texts: {},
                        decors: {},
                        layers: {}
                    };

                    number++;
                }
            }
        } else {
            el._parent.workData.workareas[1] = {
                width: el.WORKAREA_WIDTH,
                height: el.workData.height,
                top: 0,
                left: 0,
                source_width: sourceDimensions.width,
                source_height: sourceDimensions.height,
                format_id: el.format.current.id,
                cells: {},
                images: {},
                backgrounds: {},
                texts: {},
                decors: {},
                layers: {}
            };
        }
    };

    el.changeDimensions = function () {
        var sourceDimensions = {
            width: el.format.current.width,
            height: el.format.current.height
        };

        if (el.workData.orientation === 1) {
            sourceDimensions = {
                width: el.format.current.height,
                height: el.format.current.width
            };
        }

        reinit(sourceDimensions);
        el.render();
    };

    el.rotateDimensions = function () {
        el._parent.workData.orientation = el._parent.workData.orientation === 1 ? 0 : 1;

        var sourceDimensions = {
            width: el.format.current.width,
            height: el.format.current.height
        };

        if (el.workData.orientation === 1) {
            sourceDimensions = {
                width: el.format.current.height,
                height: el.format.current.width
            };
        }

        reinit(sourceDimensions);
        el.render();
    };

    el.render = function (partial) {
        el.templateData = {
            partial: partial,
            width: el.workData.width,
            height: el.workData.height,
            sid: window.bookSid,
            workareas: []
        };

        var pos = getViewArea();
        el.templateData.mainheight = pos.height;
        el.templateData.mainwidth = pos.width;

        var scale = el.workData.source_width / el.workData.width;
        var newCutAreaWidth = el.currentProduct.company.valve / el.MM_IN_PIXELS / scale;

        var workareaId, workarea, templateWorkArea;
        for (workareaId in el.workData.workareas) {
            workarea = el.workData.workareas[workareaId];

            templateWorkArea = {
                workarea_id: workareaId,
                width: workarea.width,
                height: workarea.height,
                top: workarea.top,
                left: workarea.left
            };

            if (el.workData.is_single_content !== '1') {
                templateWorkArea.cutArea = {
                    x1: 0,
                    y1: 0,
                    width1: templateWorkArea.width,
                    height1: templateWorkArea.height,
                    x2: newCutAreaWidth,
                    y2: newCutAreaWidth,
                    width2: templateWorkArea.width - newCutAreaWidth,
                    height2: templateWorkArea.height - newCutAreaWidth
                };
            }

            // generated backgrounds, cells, texts
            templateWorkArea.backgrounds = [];
            var i, minRatio = 2;
            var images = $.extend(true, {}, workarea.backgrounds);
            var image;
            for (i in images) {
                if (images.hasOwnProperty(i) && images[i] !== null) {
                    image = images[i];
                    image.id = i;

                    minRatio = el.format.items[workarea.format_id].min_ratio;

                    if (workarea.source_width / image.data_width >= minRatio || workarea.source_height / image.data_height >= minRatio) {
                        image.is_low_resolution = true;
                    }

                    switch (image.type) {
                        case 'custom':
                            image.url = window.location.origin + el.projectsPath + '/' + window.bookSid + '/workimages/' + image.name;
                            break;
                    }
                    templateWorkArea.backgrounds.push(image);
                }
            }

            templateWorkArea.layers = el.layer.getTemplateLayers(workareaId);

            templateWorkArea.texts = [];
            var i, j, rows, text;
            for (i in workarea.texts) {
                text = $.extend(true, {}, workarea.texts[i]);
                rows = $.extend(true, {}, text.rows);
                text.rows = [];

                for (j in rows) {
                    text.rows.push(rows[j]);
                }

                templateWorkArea.texts.push(text);
            }

            el.templateData.workareas.push(templateWorkArea);
        }

        var output = window.Mustache.render($('#constructor-hardcover-template').html(), el.templateData);
        $('#hardcover-wrapper').html(output);

        var $el = $('#constructor-hardcover');
        el.workAreaScale = $el.width() / el.workData.width;

        $('.format-name').text(el.format.current.name);
    };

    el.show = function () {
        var templateData = {
            items: []
        };
        
        var price = el.calculator.price[el.calculator.priceGroupId][el.project.current.product_id];
        var propertyTypes = el.calculator.propertyTypes;
        var properties = el.calculator.properties;

        var i, j, workareaFormat, workarea, format, scale, templateItem;
        var propertyType, property, cost, isSet;
        for (i in el.workareas) {
            cost = 0;
            workarea = el.workareas[i];

            templateItem = {
                id: workarea.id,
                name: parseInt(workarea.width / 10) + 'x' + parseInt(workarea.height / 10),
                height: parseInt(180 * workarea.height / workarea.width),
                viewHeight: parseInt(el.WORKAREA_WIDTH * workarea.height / workarea.width),
                formats: []
            };

            scale = workarea.width / el.MM_IN_PIXELS / el.WORKAREA_WIDTH;

            for (j in el.workarea_formats) {
                workareaFormat = el.workarea_formats[j];

                if (workareaFormat.workarea_id !== workarea.id) {
                    continue;
                }
                
                if (
                    !price.hasOwnProperty('0')
                    || !price[0].hasOwnProperty(workareaFormat.format_id)
                ) {
                    cost = 0;
                    break;
                }

                cost += parseFloat(price[0][workareaFormat.format_id]);
                
                for (propertyType in propertyTypes) {
                    isSet = false;
                    
                    for (property in properties) {
                        if (isSet) {
                            continue;
                        }
                        
                        if (property.property_type_id !== propertyType.id) {
                            continue;
                        }
                        
                        if (
                            price.hasOwnProperty(property.id)
                            && price[property.id].hasOwnProperty(workareaFormat.format_id)
                        ) {
                            cost += parseFloat(price[property.id][workareaFormat.format_id]);
                        }
                        
                        isSet = true;
                    }
                }

                format = el.format.items[workareaFormat.format_id];

                templateItem.formats.push({
                    width: format.width / el.MM_IN_PIXELS / scale,
                    height: format.height / el.MM_IN_PIXELS / scale,
                    x: workareaFormat.x / el.MM_IN_PIXELS / scale,
                    y: workareaFormat.y / el.MM_IN_PIXELS / scale
                });
            }
            
            if (parseInt(cost) === 0) {
                continue;
            }

            templateData.items.push(templateItem);
        }

        el.dialog.show('interior_workareas', templateData);
    };

    el.set = function (workareaId) {
        el.upImages.reset();
        setCurrentWorkarea(workareaId);
        el.init();
        el.render();
        el.calculator.init();
        app.dialog.hide('interior_workareas');
    };

    el.getDimensions = function () {
        var width = Math.round((el.workData.source_width - 2 * parseInt(el.currentProduct.company.valve) / el.MM_IN_PIXELS) * el.MM_IN_PIXELS / 10);
        var height = Math.round((el.workData.source_height - 2 * parseInt(el.currentProduct.company.valve) / el.MM_IN_PIXELS) * el.MM_IN_PIXELS / 10);

        return width + 'x' + height;
    };

    $('.js-workareas-show').on('click', function () {
        el.show();
    });
    $(document).on('click', '.js-set-workarea', function () {
        el.set($(this).attr('data-id'));
    });
};